const PAGES = {
  BLOG: "blog",
  TAGS: "tags",
  ABOUT: "about",
  PUBLICATIONS: "publications",
  CV: "cv"
};

const CONTENT_TYPE = {
  BLOG: "BLOG",
  PUBLICATION: "PUBLICATION",
  CV: "CV",
  ABOUT: "ABOUT",
  UNKNOWN: "UNKNOWN"
};

const CONTENT_TYPE_TO_PAGE = {
  [CONTENT_TYPE.BLOG]: PAGES.BLOG,
  [CONTENT_TYPE.PUBLICATION]: PAGES.PUBLICATIONS,
  [CONTENT_TYPE.CV]: PAGES.CV,
  [CONTENT_TYPE.ABOUT]: PAGES.ABOUT
};

module.exports = {
  PAGES,
  CONTENT_TYPE,
  CONTENT_TYPE_TO_PAGE
};
